import React, {useMemo} from "react";
import {Box} from "@mui/material";
import {grey} from "@mui/material/colors";
import {aspTokens} from "./yamlHighlight";
import {MONOSPACE_FONT, TOKEN_COLORS_SX} from "./dlvStyles";

/**
 * Read-only view of a logic program with syntax highlighting and line numbers.
 * The numbers are drawn with CSS counters, so selecting and copying gives the plain text.
 */
export function AspCodeView({text}) {
    const lines = useMemo(() => {
        const rows = text.replace(/\r\n/g, '\n').split('\n');
        if (rows.length > 1 && rows[rows.length - 1] === '') {
            rows.pop();
        }
        return rows.map(aspTokens);
    }, [text]);

    return (
        <Box
            component="pre"
            role="region"
            aria-label="Contenuto del programma"
            tabIndex={0}
            sx={{
                m: 0,
                p: 2,
                bgcolor: grey[50],
                fontFamily: MONOSPACE_FONT,
                fontSize: 13,
                lineHeight: 1.65,
                counterReset: 'line',
                overflow: 'auto',
                ...TOKEN_COLORS_SX,
                '& .line': {
                    display: 'block',
                    position: 'relative',
                    pl: '3.6em',
                    minHeight: '1.65em',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    '&::before': {
                        counterIncrement: 'line',
                        content: 'counter(line)',
                        position: 'absolute',
                        left: 0,
                        width: '2.8em',
                        textAlign: 'right',
                        color: grey[600],
                        userSelect: 'none'
                    }
                }
            }}>
            {lines.map((tokens, i) =>
                <span className="line" key={i}>
                    {tokens.map((token, j) => token.type
                        ? <span key={j} className={`tok-${token.type}`}>{token.text}</span>
                        : token.text)}
                    {tokens.length === 0 ? '​' : null}
                </span>)}
        </Box>
    );
}
